import { OtherTheme, Theme } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';

import { ThematicFocusCard } from './components/ThematicFocusCard';
import { isTheme } from './components/utils';
import * as S from './ThematicFocus.styles';

interface ThematicFocusProps {
  themes: Theme[];
  otherThemes: OtherTheme[];
  title: string;
  withPill?: boolean;
}

export const ThematicFocus = ({
  themes,
  otherThemes,
  title,
  withPill = false,
}: ThematicFocusProps) => {
  const allThemes = [...themes, ...otherThemes];
  const totalThemes = allThemes.length;

  return (
    <>
      <S.Title>{title}</S.Title>
      <S.Root>
        <ErrorBoundaryWrapper>
          {allThemes.map((theme, index) => (
            <ThematicFocusCard
              key={isTheme(theme) ? theme.theme_id : theme.name}
              theme={theme}
              isLast={index === totalThemes - 1}
              withPill={withPill}
            />
          ))}
        </ErrorBoundaryWrapper>
      </S.Root>
    </>
  );
};
